import { render } from "./reply_button.vue?vue&type=template&id=acab8e28"
import script from "./reply_button.js?vue&type=script&lang=js&external"
export * from "./reply_button.js?vue&type=script&lang=js&external"

import "./reply_button.vue?vue&type=style&index=0&id=acab8e28&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__